import { analytics } from "@/lib/analytics/analytics";
import { AnalyticsEvents } from "@/lib/analytics/events";

export function trackHeroGetStarted(source: string): void {
  analytics.capture(AnalyticsEvents.heroGetStartedClicked, { source });
}
